(function () {
  const SELECTORS = {
    product: 'body.template-product .product:not(.product--no-media)',
    wrapper: 'body.template-product .product__media-wrapper',
    gallery: 'body.template-product .product__media-wrapper media-gallery',
    header: '.section-header',
    stickyAtc: '#bundle-sticky_add_to_cart',
  };

  const state = {
    ticking: false,
    mediaQuery: window.matchMedia('(min-width: 990px)'),
  };

  function reset() {
    document.body.classList.remove('paws-pdp-media-fixed');
    document.documentElement.style.removeProperty('--paws-pdp-media-top');
    document.documentElement.style.removeProperty('--paws-pdp-media-left');
    document.documentElement.style.removeProperty('--paws-pdp-media-width');
    document.documentElement.style.removeProperty('--paws-pdp-media-max-height');
    document.documentElement.style.removeProperty('--paws-pdp-media-main-max-height');

    const wrapper = document.querySelector(SELECTORS.wrapper);
    if (wrapper) {
      wrapper.style.minHeight = '';
    }
  }

  function getStickyAtcHeight() {
    const stickyAtc = document.querySelector(SELECTORS.stickyAtc);
    if (!stickyAtc) return 0;

    const rect = stickyAtc.getBoundingClientRect();
    const isVisible = rect.width > 0 && rect.height > 0 && window.getComputedStyle(stickyAtc).display !== 'none';
    return isVisible ? rect.height : 0;
  }

  function getTopOffset() {
    const header = document.querySelector(SELECTORS.header);
    const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    return Math.max(headerBottom + 16, 120);
  }

  function update() {
    state.ticking = false;

    if (!document.body.classList.contains('template-product') || !state.mediaQuery.matches) {
      reset();
      return;
    }

    const product = document.querySelector(SELECTORS.product);
    const wrapper = document.querySelector(SELECTORS.wrapper);
    const gallery = document.querySelector(SELECTORS.gallery);

    if (!product || !wrapper || !gallery) {
      reset();
      return;
    }

    const productRect = product.getBoundingClientRect();
    const wrapperRect = wrapper.getBoundingClientRect();
    const topOffset = getTopOffset();
    const bottomOffset = getStickyAtcHeight() + 18;
    const maxHeight = Math.max(360, window.innerHeight - topOffset - bottomOffset);
    const thumbnailSlider = gallery.querySelector('[id^="GalleryThumbnails"]');
    const thumbnailHeight = thumbnailSlider ? thumbnailSlider.offsetHeight : 0;
    const mainMaxHeight = Math.max(260, maxHeight - thumbnailHeight - (thumbnailHeight > 0 ? 12 : 0));
    const naturalHeight = gallery.offsetHeight || wrapperRect.width;
    const fixedHeight = Math.min(naturalHeight, maxHeight);
    const shouldFix = productRect.top <= topOffset && productRect.bottom > topOffset + fixedHeight + 24;

    wrapper.style.minHeight = `${naturalHeight}px`;

    if (!shouldFix) {
      document.body.classList.remove('paws-pdp-media-fixed');
      return;
    }

    document.documentElement.style.setProperty('--paws-pdp-media-top', `${topOffset}px`);
    document.documentElement.style.setProperty('--paws-pdp-media-left', `${wrapperRect.left}px`);
    document.documentElement.style.setProperty('--paws-pdp-media-width', `${wrapperRect.width}px`);
    document.documentElement.style.setProperty('--paws-pdp-media-max-height', `${maxHeight}px`);
    document.documentElement.style.setProperty('--paws-pdp-media-main-max-height', `${mainMaxHeight}px`);
    document.body.classList.add('paws-pdp-media-fixed');
  }

  function requestUpdate() {
    if (state.ticking) return;
    state.ticking = true;
    window.requestAnimationFrame(update);
  }

  document.addEventListener('DOMContentLoaded', requestUpdate);
  window.addEventListener('load', requestUpdate, { once: true });
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);

  if (state.mediaQuery.addEventListener) {
    state.mediaQuery.addEventListener('change', requestUpdate);
  }
})();
